import React, { Component } from "react";
import classnames from "classnames";
import styles from "./CategoriesSettings.local.scss";
import Select from "react-select";
import _ from "i18n";
import { Switch } from "antd";

class CategorySettingsSideBar extends Component {
  isEditingLabels = () => {
    return !(
      this.props.labelsForm.fr ||
      this.props.labelsForm.en ||
      this.props.labelsForm.nl
    );
  };

  render() {
    const {
      saving,
      isAddingCategory,
      labelsForm,
      superCategoriesOptions,
      analysisPlanOptions,
      valuationOptions,
      associated,
      isBillable
    } = this.props;

    return (
      <div
        className={classnames(
          styles.sidebar,
          isAddingCategory ? styles.display : ""
        )}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={() => this.props.onCancelNewCategory()}
          alt={""}
        />
        {this.props.filterAdding === "categories" ? (
          <div className={styles.sidebar__titles}>
            <h4>{_("addCategory")}</h4>
            <h5>{_("typeTitleCategory")}</h5>
          </div>
        ) : this.props.filterAdding === "analysisPlan" ? (
          <div className={styles.sidebar__titles}>
            <h4>{_("addAnalysisPlan")}</h4>
            <h5>{_("typeTitleAnalysisPlan")}</h5>
          </div>
        ) : this.props.filterAdding === "valuation" ? (
          <div className={styles.sidebar__titles}>
            <h4>{"Ajouter valuation"}</h4>
            <h5>{_("typeTitleValuation")}</h5>
          </div>
        ) : (
          <div className={styles.sidebar__titles}>
            <h4>{_("addSuperCategory")}</h4>
            <h5>{_("typeTitleSuperCategory")}</h5>
          </div>
        )}
        <div className={styles.category_selected}>
          {this.props.filterAdding === "categories" ? (
            <div className={styles.selected}>
              <div className={classnames(styles.block1, styles.block2)}>
                <div
                  className={styles.active}
                  style={{ width: "114px!important" }}
                >
                  <div className={styles.label}>{_("Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("categories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("super Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("superCategories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
              <div className={classnames(styles.block1)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Analysis Plan")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("analysisPlan")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("classification")}</div>
                  <span
                    onClick={() => this.props.onChangeFilterAdding("valuation")}
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
            </div>
          ) : this.props.filterAdding === "superCategories" ? (
            <div className={styles.selected}>
              <div className={classnames(styles.block1, styles.block2)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("categories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.active}>
                  <div className={styles.label}>{_("super Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("superCategories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
              <div className={classnames(styles.block1)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Analysis Plan")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("AnalysisPlan")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("classification")}</div>
                  <span
                    onClick={() => this.props.onChangeFilterAdding("valuation")}
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
            </div>
          ) : this.props.filterAdding === "valuation" ? (
            <div className={styles.selected}>
              <div className={classnames(styles.block1, styles.block2)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("categories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("super Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("superCategories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
              <div className={classnames(styles.block1)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Analysis Plan")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("AnalysisPlan")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.active}>
                  <div className={styles.label}>{_("classification")}</div>
                  <span
                    onClick={() => this.props.onChangeFilterAdding("valuation")}
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.selected}>
              <div className={classnames(styles.block1, styles.block2)}>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("categories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("super Category")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("superCategories")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
              <div className={classnames(styles.block1)}>
                <div className={styles.active}>
                  <div className={styles.label}>{_("Analysis Plan")}</div>
                  <span
                    onClick={() =>
                      this.props.onChangeFilterAdding("AnalysisPlan")
                    }
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
                <div className={styles.Inactive}>
                  <div className={styles.label}>{_("classification")}</div>
                  <span
                    onClick={() => this.props.onChangeFilterAdding("valuation")}
                  >
                    <div className={styles.first_span} />
                    <div className={styles.second_span} />
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={styles.labels_form_block}>
          <span>
            <img src={"/img/icons/fr_flag.svg"} alt={""} />
            {_("french")}
          </span>
          <div>
            <input
              type={"text"}
              placeholder={_("frenchTitle")}
              value={labelsForm.fr}
              onChange={e => this.props.onChangeLabelFormFr(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span>
            <img src={"/img/icons/en_flag.svg"} alt={""} />
            {_("english")}
          </span>
          <div>
            <input
              type={"text"}
              placeholder={_("englishTitle")}
              value={labelsForm.en}
              onChange={e => this.props.onChangeLabelFormEn(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span>
            <img src={"/img/icons/nl_flag.svg"} alt={""} />
            {_("dutch")}
          </span>
          <div>
            <input
              type={"text"}
              placeholder={_("dutchTitle")}
              value={labelsForm.nl}
              onChange={e => this.props.onChangeLabelFormNl(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
        </div>

        {associated ? (
          <div className={styles.div}>
            <span className={styles.span_label}>
              <i className={classnames("icon icon-tag", styles.link_icon)} />
              {_("AssociatedWith")}
            </span>

            <Select
              value={
                this.props.selectedSuperCategory &&
                superCategoriesOptions.find(
                  obj => obj.value === this.props.selectedSuperCategory
                )
              }
              onChange={this.props.onChangeSelectedSuperCategory}
              options={superCategoriesOptions}
              className={"select_large"}
              classNamePrefix="ttp-select"
              isClearable={true}
              placeholder={_("SuperCategory")}
              menuPlacement="auto"
            />
            <span className={styles.span_label}>
              <i className={classnames("icon icon-tag", styles.link_icon)} />
              {_("BelongsTo")}
            </span>

            <Select
              value={
                this.props.selectedAnalysisPlan &&
                analysisPlanOptions.find(
                  obj => obj.value === this.props.selectedAnalysisPlan
                )
              }
              onChange={this.props.onChangeSelectedAnalysisPlan}
              options={analysisPlanOptions}
              className={"select_large"}
              classNamePrefix="ttp-select"
              isClearable={true}
              placeholder={_("AnalysisPlan")}
              menuPlacement="auto"
            />
            <span className={styles.span_label}>
              <i className={classnames("icon icon-tag", styles.link_icon)} />
              {_("classified")}
            </span>

            <Select
              value={
                this.props.selectedValuation &&
                valuationOptions.find(
                  obj => obj.value === this.props.selectedValuation
                )
              }
              onChange={this.props.onChangeSelectedValuation}
              options={valuationOptions}
              className={"select_large"}
              classNamePrefix="ttp-select"
              isClearable={true}
              placeholder={_("classification")}
              menuPlacement="auto"
            />

            <div style={{ display: "inline-flex", paddingTop: "2%" }}>
              <span className={styles.span_label}>
                <i className={classnames("icon icon-tag", styles.link_icon)} />
                {_("isBillable")}
              </span>
              <span className={styles.etat_block}>
                <Switch
                  checked={isBillable}
                  onChange={() => this.props.handleChangeBillableState()}
                />
              </span>
            </div>
          </div>
        ) : (
          ""
        )}

        {this.props.filterAdding === "valuation" ? (
          <div
            className={styles.labels_form_block}
            style={{ marginTop: "-50px" }}
          >
            <span>
              <i className={classnames("icon icon-tag", styles.link_icon)} />
              {_("coefficient")}
            </span>
            <div>
              <input
                type={"number"}
                placeholder={_("coefficient")}
                value={labelsForm.coefficient}
                onChange={e => this.props.onChangeLabelFormCoefficient(e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className={styles.actions_block}>
          <button
            className={styles.cancel_btn}
            onClick={() => this.props.onCancelNewCategory()}
          >
            {_("cancel")}
          </button>
          <button
            className={styles.save_button}
            onClick={() => this.props.handleSaveNewCategory()}
            disabled={this.isEditingLabels()}
          >
            <img
              src={"/img/icons/tail-spin.svg"}
              alt={""}
              className={saving ? styles.loading : ""}
            />
            {_("save")}
          </button>
        </div>
      </div>
    );
  }
}

export default CategorySettingsSideBar;



// WEBPACK FOOTER //
// ./src/components/CategorySettings/CategorySettingsSideBar.js